import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { StatBlockComponent } from '@rma/dashboard/generic/ui/stat-block';
import { RmaIconComponent, RmaIcons } from '@rma/generic/ui/icon';
import { PlatformReviewInfo } from '../domain/platform-review-info.model';

@Component({
  selector: 'rma-my-subscription-integration-card',
  imports: [LowerCasePipe, RmaIconComponent, TranslocoModule, StatBlockComponent],
  templateUrl: './my-subscription-integration-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MySubscriptionIntegrationCardComponent {
  @Input() platform: string;
  @Input() platformIcon: RmaIcons | null;
  @Input() reviewInfo: PlatformReviewInfo | null;
}
